module.exports = __webpack_public_path__ + "static/media/YF74_04.1a804580.jpg";